const ProductListTable = {
  init(target) {
    const priceCells = target.querySelectorAll('.productrow__yourprice')
    this.loadPrices(priceCells)
    window.addEventListener('scroll', () => this.loadPrices(priceCells))
  },
  loadPrices(priceCells) {
    priceCells.forEach((cell) => {
      if (this.isInViewport(cell) && !cell.classList.contains('loaded')) {
        const SKU = cell.dataset.sku
        const cellSpan = cell.querySelector('span')
        const modalPrice = cell.parentNode.querySelector('.cartlist__price p')

        cellSpan.innerHTML = `<div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>`

        fetch(`/umbraco/api/customer/getcustomerprice?itemId=${SKU}`, {
          method: 'GET',
        })
          .then((res) => res.json())
          .then((response) => {
            if (response) {
              cellSpan.innerHTML = `<span>${response}</span>`
              cell.classList.add('loaded')

              if (modalPrice) {
                modalPrice.innerHTML = `<span>${response}</span>`
              }
            } else {
              console.log(response, 'error')
              cell.classList.add('loaded')
              cellSpan.innerHTML = response
            }
          })
          .catch((ex) => {
            console.log(`Server error: ${ex}`, 'error')
          })
      }
    })
  },
  isInViewport(element: HTMLDivElement) {
    const rect = element.getBoundingClientRect()
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    )
  },
}

export default ProductListTable
